module.exports = __webpack_public_path__ + "static/img/27.fd52c54e.webp";